import { Component, HostListener } from '@angular/core';
import { setTheme } from 'ngx-bootstrap/utils';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  host: { 'window:beforeunload': 'clearFirebaseListner' }
})
export class AppComponent {
  @HostListener('window:beforeunload')
  clearFirebaseListner() {
    // console.log('change detect');
    localStorage.removeItem('firebaseListner');
    localStorage.removeItem('firebaseListner_Dashboard');
  }

  title = 'deliverygate-admin-front-end';

  constructor() {
    setTheme('bs4'); // or 'bs4'

  }

  ngOnInit(): void {

    console.log = function () { }
  }
}
